module.exports = __webpack_public_path__ + "img/299.790a4f60.jpg";